import { STEP_ORDER as S, isStepComplete as j, computeQuote as N, formatCents as I, stepIndexOf as q, STEP_HEADINGS as b, getStepOptions as E, getEffectiveSelection as D, derivedDimensions as U, validateLead as B, buildQuotePayload as G, mergeConfig as Q, defaultConfig as Y, reduce as K, createInitialState as V } from "./core.js";
import { CONFIGURATOR_VERSION as De, MSG_SELECT_MODEL as Pe, MSG_SELECT_TO_CONTINUE as qe, PRICED_STEPS as _e, STEP_LABELS as Ae, basePriceCents as Re, floorSqFt as $e, getInclusion as Fe, includedOptionId as Me, isUpgradeOptionId as je, loftPriceCents as Ue, loftUpgradeDeltaCents as Be, optionPriceCents as Ge, optionTitle as Qe, paintableSqFt as Ye, priceQuote as Ke, shortestWallFt as Ve, validateSelection as He } from "./core.js";
import { jsx as t, jsxs as c, Fragment as y } from "react/jsx-runtime";
import { createContext as H, useContext as W, useEffect as C, forwardRef as J, useRef as T, useState as _, useMemo as z, useReducer as Z } from "react";
const R = H(null);
function x() {
  const e = W(R);
  if (!e)
    throw new Error("useConfigurator must be used inside <ShedConfigurator />");
  return e;
}
const $ = {
  anchor: "/configurator/anchors/auger.webp",
  blocks: "/configurator/foundation/out-of-level-shed.webp",
  floor: "/configurator/flooring/flooring-0.webp",
  loft: "/configurator/loft/loft.webp",
  none: "/configurator/none/none.png",
  obstruction: "/configurator/Headache.webp",
  ramp: "/configurator/ramp/shed-ramp.webp",
  shelving: "/configurator/shelving/shelving.webp",
  shingles: "/configurator/shingles/3-tab-shingles.webp",
  "shingles-arch": "/configurator/shingles/architectural-shingles.webp",
  solar: "/configurator/venting/solar-vent-fan.webp",
  vent: "/configurator/venting/complete-venting.webp",
  window: "/configurator/window/shed-window.webp",
  workbench: "/configurator/workbench/workbench-1.webp"
}, X = /* @__PURE__ */ new Set(["none"]);
function ee(e) {
  return $[e];
}
function te({ kind: e }) {
  const s = $[e];
  if (!s) return null;
  const r = X.has(e);
  return /* @__PURE__ */ t(
    "img",
    {
      className: `shdcfg-card-photo${r ? " shdcfg-card-photo--contain" : ""}`,
      src: s,
      alt: "",
      "aria-hidden": "true",
      loading: "lazy"
    }
  );
}
function se() {
  return /* @__PURE__ */ t("svg", { viewBox: "0 0 16 16", fill: "none", "aria-hidden": "true", children: /* @__PURE__ */ t(
    "path",
    {
      d: "m3 8.5 3.5 3.5L13 5",
      stroke: "currentColor",
      strokeWidth: "2.4",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ) });
}
function re() {
  const { state: e, dispatch: s, config: r } = x(), i = S[e.stepIndex], o = j(i, e, r), n = N(e, r);
  return /* @__PURE__ */ c(y, { children: [
    e.advanceError && /* @__PURE__ */ t("p", { className: "shdcfg-error", role: "alert", children: e.advanceError }),
    /* @__PURE__ */ c("div", { className: "shdcfg-nav", children: [
      /* @__PURE__ */ t(
        "button",
        {
          type: "button",
          className: "shdcfg-btn shdcfg-btn-ghost",
          onClick: () => s({ type: "BACK_STEP" }),
          disabled: e.stepIndex === 0,
          children: "Back"
        }
      ),
      /* @__PURE__ */ c("div", { className: "shdcfg-nav-total", children: [
        "Current total",
        /* @__PURE__ */ t("strong", { children: I(n.totalCents) })
      ] }),
      /* @__PURE__ */ t(
        "button",
        {
          type: "button",
          className: "shdcfg-btn shdcfg-btn-primary",
          "aria-disabled": !o,
          onClick: () => s({ type: "ADVANCE_STEP" }),
          children: "Continue"
        }
      )
    ] })
  ] });
}
const oe = [
  { label: "Size", steps: ["model"] },
  { label: "Paint", steps: ["paint"] },
  { label: "Roof", steps: ["roofing"] },
  { label: "Flooring", steps: ["flooring", "foundation"] },
  { label: "Options", steps: ["workbench", "loft", "shelving", "venting", "window", "delivery", "anchors", "ramp"] },
  { label: "Quote", steps: ["quote"] }
];
function ne() {
  const { state: e } = x(), s = e.stepIndex / (S.length - 1) * 100;
  return /* @__PURE__ */ c("nav", { className: "shdcfg-stepper", "aria-label": "Configuration progress", children: [
    /* @__PURE__ */ t("ol", { className: "shdcfg-stepper-groups", children: oe.map((r, i) => {
      const o = q(r.steps[0]), n = q(r.steps[r.steps.length - 1]), a = e.stepIndex >= o && e.stepIndex <= n, h = e.stepIndex > n;
      return /* @__PURE__ */ c(
        "li",
        {
          className: `shdcfg-stepper-group${a ? " is-current" : ""}${h ? " is-done" : ""}`,
          "aria-current": a ? "step" : void 0,
          children: [
            /* @__PURE__ */ t("span", { className: "shdcfg-stepper-num", "aria-hidden": "true", children: i + 1 }),
            r.label
          ]
        },
        r.label
      );
    }) }),
    /* @__PURE__ */ t(
      "div",
      {
        className: "shdcfg-stepper-track",
        role: "progressbar",
        "aria-valuenow": Math.round(s),
        "aria-valuemin": 0,
        "aria-valuemax": 100,
        "aria-label": "Overall progress",
        children: /* @__PURE__ */ t("div", { className: "shdcfg-stepper-fill", style: { width: `${s}%` } })
      }
    )
  ] });
}
function F() {
  const { state: e, config: s } = x(), r = N(e, s);
  return /* @__PURE__ */ c("div", { className: "shdcfg-ticket", children: [
    /* @__PURE__ */ c("div", { className: "shdcfg-ticket-title", children: [
      /* @__PURE__ */ t("span", { children: "Your quote" }),
      /* @__PURE__ */ c("span", { "aria-hidden": "true", children: [
        "№ ",
        s.version
      ] })
    ] }),
    r.lineItems.length === 0 ? /* @__PURE__ */ t("p", { className: "shdcfg-ticket-hint", children: "Pick a shed model and size to start your quote." }) : /* @__PURE__ */ t("ul", { className: "shdcfg-ticket-rows", children: r.lineItems.map((i) => /* @__PURE__ */ c(
      "li",
      {
        className: `shdcfg-ticket-row${i.included ? " is-included" : ""}`,
        children: [
          /* @__PURE__ */ c("span", { children: [
            i.label,
            /* @__PURE__ */ t("span", { className: "shdcfg-ticket-detail", children: i.detail })
          ] }),
          /* @__PURE__ */ t("span", { className: "shdcfg-ticket-price", children: i.stepId === "model" ? "—" : i.included ? "Included" : i.price })
        ]
      },
      i.stepId
    )) }),
    /* @__PURE__ */ c("div", { className: "shdcfg-ticket-total", children: [
      /* @__PURE__ */ t("span", { children: "Total" }),
      /* @__PURE__ */ t("strong", { children: I(r.totalCents) })
    ] }),
    /* @__PURE__ */ t("p", { className: "shdcfg-ticket-hint", children: "Prices update live as you make selections." })
  ] });
}
function de() {
  return /* @__PURE__ */ t("aside", { className: "shdcfg-rail", "aria-label": "Running price summary", children: /* @__PURE__ */ t(F, {}) });
}
function ie() {
  const { state: e, config: s } = x(), r = N(e, s);
  return /* @__PURE__ */ c("details", { className: "shdcfg-drawer", children: [
    /* @__PURE__ */ c("summary", { children: [
      /* @__PURE__ */ t("span", { children: "Price summary" }),
      /* @__PURE__ */ t("span", { children: I(r.totalCents) })
    ] }),
    /* @__PURE__ */ t(F, {})
  ] });
}
function k({ heading: e, subheading: s, children: r }) {
  return /* @__PURE__ */ c("section", { children: [
    /* @__PURE__ */ t("h2", { className: "shdcfg-step-heading", children: e }),
    s && /* @__PURE__ */ t("p", { className: "shdcfg-step-sub", children: s }),
    r
  ] });
}
function ce() {
  var o;
  const { state: e, dispatch: s, config: r } = x(), i = e.modelLocked && e.dimensionsLocked;
  if (C(() => {
    if (!e.modelLocked && !e.model) {
      const n = e.dimensions, a = (d) => {
        var l, f;
        return n != null && ((f = (l = r.basePrices) == null ? void 0 : l[d]) == null ? void 0 : f[`${n.w}x${n.l}`]) != null;
      }, h = r.models.find((d) => a(d.id)) ?? r.models.find((d) => d.id === "utility") ?? r.models[0];
      h && s({ type: "SELECT_MODEL", model: h.id });
    }
  }, [e.model, e.modelLocked, e.dimensions, r.models, r.basePrices, s]), i && e.model && e.dimensions) {
    const n = ((o = r.models.find((a) => a.id === e.model)) == null ? void 0 : o.name) ?? e.model;
    return /* @__PURE__ */ t(k, { heading: "Confirm your shed.", children: /* @__PURE__ */ t("div", { className: "shdcfg-confirm", children: /* @__PURE__ */ c("div", { children: [
      /* @__PURE__ */ c("p", { className: "shdcfg-confirm-title", children: [
        "You're configuring: ",
        e.dimensions.w,
        "×",
        e.dimensions.l,
        " ",
        n
      ] }),
      /* @__PURE__ */ t("p", { className: "shdcfg-confirm-note", children: "Picked on the product page — press Continue to start choosing options." })
    ] }) }) });
  }
  return /* @__PURE__ */ t(
    k,
    {
      heading: b.model,
      subheading: "Pick the size that fits — it drives square-footage pricing for the steps that follow.",
      children: /* @__PURE__ */ t(ae, {})
    }
  );
}
function ae() {
  var p;
  const { state: e, dispatch: s, config: r } = x();
  if (e.dimensionsLocked && e.dimensions)
    return /* @__PURE__ */ c(y, { children: [
      /* @__PURE__ */ t("h3", { className: "shdcfg-section-label", children: "Size" }),
      /* @__PURE__ */ c("p", { className: "shdcfg-confirm-note", children: [
        e.dimensions.w,
        "×",
        e.dimensions.l,
        " ft — locked by the page you came from."
      ] })
    ] });
  const i = e.model ? (p = r.basePrices) == null ? void 0 : p[e.model] : void 0, o = i ? r.sizes.filter((g) => i[`${g.w}x${g.l}`] != null) : r.sizes, n = o.length > 0 ? o : r.sizes, a = [], h = n.findIndex(
    (g) => {
      var m, v;
      return g.w === ((m = e.dimensions) == null ? void 0 : m.w) && g.l === ((v = e.dimensions) == null ? void 0 : v.l);
    }
  ), d = Math.max(0, h), l = (g) => s({ type: "SELECT_SIZE", dimensions: n[g] }), f = (g, m) => {
    var u;
    const v = (g + m + n.length) % n.length;
    (u = a[v]) == null || u.focus(), l(v);
  };
  return /* @__PURE__ */ c(y, { children: [
    /* @__PURE__ */ t("h3", { className: "shdcfg-section-label", children: "Size (W × L, feet)" }),
    /* @__PURE__ */ t("div", { className: "shdcfg-chips", role: "radiogroup", "aria-label": "Shed size", children: n.map((g, m) => {
      const v = m === h;
      return /* @__PURE__ */ c(
        "button",
        {
          ref: (u) => {
            a[m] = u;
          },
          type: "button",
          role: "radio",
          "aria-checked": v,
          tabIndex: m === d ? 0 : -1,
          className: `shdcfg-chip${v ? " is-selected" : ""}`,
          onClick: () => l(m),
          onKeyDown: (u) => {
            u.key === "ArrowRight" || u.key === "ArrowDown" ? (u.preventDefault(), f(m, 1)) : u.key === "ArrowLeft" || u.key === "ArrowUp" ? (u.preventDefault(), f(m, -1)) : (u.key === " " || u.key === "Enter") && (u.preventDefault(), l(m));
          },
          children: [
            g.w,
            "×",
            g.l
          ]
        },
        `${g.w}x${g.l}`
      );
    }) })
  ] });
}
const le = J(function({ option: s, selected: r, tabIndex: i, onSelect: o, onKeyDown: n }, a) {
  const h = !!s.included;
  return /* @__PURE__ */ c(
    "div",
    {
      ref: a,
      role: "radio",
      "aria-checked": r,
      "aria-label": `${s.title}, ${s.included ? "included" : s.priceLabel}`,
      tabIndex: i,
      className: `shdcfg-card${r ? " is-selected" : ""}${h ? " is-locked" : ""}`,
      onClick: o,
      onKeyDown: n,
      children: [
        ee(s.art) && /* @__PURE__ */ t("div", { className: "shdcfg-card-media", children: /* @__PURE__ */ t(te, { kind: s.art }) }),
        /* @__PURE__ */ c("div", { className: "shdcfg-card-body", children: [
          s.includedLabel && /* @__PURE__ */ t("span", { className: "shdcfg-card-included-badge", children: s.includedLabel }),
          /* @__PURE__ */ t("span", { className: "shdcfg-card-title", children: s.title }),
          s.specNote && /* @__PURE__ */ t("span", { className: "shdcfg-card-note", children: s.specNote }),
          /* @__PURE__ */ t("span", { className: "shdcfg-card-price", children: s.priceLabel })
        ] })
      ]
    }
  );
});
function L({ options: e, selectedId: s, onSelect: r, ariaLabel: i }) {
  const o = T([]), n = s != null ? Math.max(
    0,
    e.findIndex((d) => d.id === s)
  ) : 0, a = (d, l) => {
    var g;
    const f = (d + l + e.length) % e.length, p = e[f];
    (g = o.current[f]) == null || g.focus(), p.included || r(p);
  }, h = (d) => (l) => {
    switch (l.key) {
      case "ArrowRight":
      case "ArrowDown":
        l.preventDefault(), a(d, 1);
        break;
      case "ArrowLeft":
      case "ArrowUp":
        l.preventDefault(), a(d, -1);
        break;
      case " ":
      case "Enter":
        l.preventDefault(), e[d].included || r(e[d]);
        break;
    }
  };
  return /* @__PURE__ */ t("div", { className: "shdcfg-options", role: "radiogroup", "aria-label": i, children: e.map((d, l) => /* @__PURE__ */ t(
    le,
    {
      ref: (f) => {
        o.current[l] = f;
      },
      option: d,
      selected: d.id === s,
      tabIndex: l === n ? 0 : -1,
      onSelect: () => {
        d.included || r(d);
      },
      onKeyDown: h(l)
    },
    d.id
  )) });
}
function M({ swatches: e, selectedId: s, onSelect: r, ariaLabel: i }) {
  const o = T([]), n = s != null ? Math.max(
    0,
    e.findIndex((d) => d.id === s)
  ) : 0, a = (d, l) => {
    var p;
    const f = (d + l + e.length) % e.length;
    (p = o.current[f]) == null || p.focus(), r(e[f]);
  }, h = (d) => (l) => {
    switch (l.key) {
      case "ArrowRight":
      case "ArrowDown":
        l.preventDefault(), a(d, 1);
        break;
      case "ArrowLeft":
      case "ArrowUp":
        l.preventDefault(), a(d, -1);
        break;
      case " ":
      case "Enter":
        l.preventDefault(), r(e[d]);
        break;
    }
  };
  return /* @__PURE__ */ t("div", { className: "shdcfg-swatches", role: "radiogroup", "aria-label": i, children: e.map((d, l) => {
    const f = d.id === s;
    return /* @__PURE__ */ c(
      "button",
      {
        ref: (p) => {
          o.current[l] = p;
        },
        type: "button",
        role: "radio",
        "aria-checked": f,
        tabIndex: l === n ? 0 : -1,
        className: `shdcfg-swatch${f ? " is-selected" : ""}`,
        onClick: () => r(d),
        onKeyDown: h(l),
        children: [
          /* @__PURE__ */ t("span", { className: "shdcfg-swatch-chip", style: { background: d.hex, display: "block" } }),
          /* @__PURE__ */ t("span", { className: "shdcfg-swatch-label", children: d.name })
        ]
      },
      d.id
    );
  }) });
}
function he() {
  var h;
  const { state: e, dispatch: s, config: r } = x(), i = E("paint", e, r), o = e.selections.paint, n = i.find((d) => d.id === (o == null ? void 0 : o.optionId)), a = !!(n != null && n.requiresColor) && (((h = n.colorChoices) == null ? void 0 : h.length) ?? 0) > 0;
  return C(() => {
    o || s({ type: "SELECT_OPTION", stepId: "paint", optionId: "none" });
  }, [o, s]), /* @__PURE__ */ c(
    k,
    {
      heading: b.paint,
      subheading: "Rates apply to your shed's paintable wall area.",
      children: [
        /* @__PURE__ */ t(
          L,
          {
            options: i,
            selectedId: (o == null ? void 0 : o.optionId) ?? null,
            ariaLabel: b.paint,
            onSelect: (d) => s({ type: "SELECT_OPTION", stepId: "paint", optionId: d.id })
          }
        ),
        a && /* @__PURE__ */ c(y, { children: [
          /* @__PURE__ */ t("h3", { className: "shdcfg-section-label", children: "Choose your color" }),
          /* @__PURE__ */ t(
            M,
            {
              swatches: n.colorChoices,
              selectedId: (o == null ? void 0 : o.color) ?? null,
              ariaLabel: "Paint color",
              onSelect: (d) => s({ type: "SELECT_COLOR", stepId: "paint", colorId: d.id })
            }
          )
        ] })
      ]
    }
  );
}
function pe() {
  var d;
  const { state: e, dispatch: s, config: r } = x(), i = E("loft", e, r), o = D("loft", e, r), n = U(e, r), a = i.find((l) => l.id === "loft"), h = (a == null ? void 0 : a.requiresDepth) && (o == null ? void 0 : o.optionId) === "loft";
  return /* @__PURE__ */ c(k, { heading: b.loft, subheading: "Overhead storage above the walls.", children: [
    /* @__PURE__ */ t(
      L,
      {
        options: i,
        selectedId: (o == null ? void 0 : o.optionId) ?? null,
        ariaLabel: b.loft,
        onSelect: (l) => s({
          type: "SELECT_OPTION",
          stepId: "loft",
          optionId: l.id,
          depthFt: l.depthFt
        })
      }
    ),
    h && /* @__PURE__ */ c(y, { children: [
      /* @__PURE__ */ t("h3", { className: "shdcfg-section-label", children: "Loft depth" }),
      /* @__PURE__ */ t("div", { className: "shdcfg-chips", role: "radiogroup", "aria-label": "Loft depth in feet", children: (d = a.depthChoicesFt) == null ? void 0 : d.map((l) => {
        var p;
        const f = ((p = e.selections.loft) == null ? void 0 : p.depthFt) === l;
        return /* @__PURE__ */ c(
          "button",
          {
            type: "button",
            role: "radio",
            "aria-checked": f,
            className: `shdcfg-chip${f ? " is-selected" : ""}`,
            onClick: () => s({ type: "SELECT_OPTION", stepId: "loft", optionId: "loft", depthFt: l }),
            children: [
              l,
              " ft"
            ]
          },
          l
        );
      }) })
    ] }),
    n && /* @__PURE__ */ c("p", { className: "shdcfg-constraint", children: [
      "Loft depth limited to ",
      n.shortestWallFt,
      " ft (your shortest wall)."
    ] })
  ] });
}
function fe() {
  const { state: e, dispatch: s, config: r } = x(), i = E("shelving", e, r), o = D("shelving", e, r), n = r.shelving.allowQuantity && (o == null ? void 0 : o.optionId) === "shelving";
  return /* @__PURE__ */ c(k, { heading: b.shelving, children: [
    /* @__PURE__ */ t(
      L,
      {
        options: i,
        selectedId: (o == null ? void 0 : o.optionId) ?? null,
        ariaLabel: b.shelving,
        onSelect: (a) => s({ type: "SELECT_OPTION", stepId: "shelving", optionId: a.id })
      }
    ),
    n && /* @__PURE__ */ c(y, { children: [
      /* @__PURE__ */ t("h3", { className: "shdcfg-section-label", children: "How many? (one per side)" }),
      /* @__PURE__ */ t("div", { className: "shdcfg-chips", role: "radiogroup", "aria-label": "Shelving quantity", children: Array.from({ length: r.shelving.maxQuantity }, (a, h) => h + 1).map((a) => {
        var d;
        const h = (((d = e.selections.shelving) == null ? void 0 : d.quantity) ?? 1) === a;
        return /* @__PURE__ */ t(
          "button",
          {
            type: "button",
            role: "radio",
            "aria-checked": h,
            className: `shdcfg-chip${h ? " is-selected" : ""}`,
            onClick: () => s({ type: "SET_QUANTITY", stepId: "shelving", quantity: a }),
            children: a
          },
          a
        );
      }) })
    ] })
  ] });
}
function ge() {
  const { state: e, dispatch: s, config: r } = x(), i = E("roofing", e, r), o = e.selections.roofing, n = i.find((d) => d.id === (o == null ? void 0 : o.optionId)), a = (n == null ? void 0 : n.colorChoices) ?? [], h = a.length > 0;
  return /* @__PURE__ */ c(k, { heading: b.roofing, children: [
    /* @__PURE__ */ t(
      L,
      {
        options: i,
        selectedId: (o == null ? void 0 : o.optionId) ?? null,
        ariaLabel: b.roofing,
        onSelect: (d) => s({ type: "SELECT_OPTION", stepId: "roofing", optionId: d.id })
      }
    ),
    h && /* @__PURE__ */ c(y, { children: [
      /* @__PURE__ */ t("h3", { className: "shdcfg-section-label", children: "Shingle color" }),
      /* @__PURE__ */ t(
        M,
        {
          swatches: a,
          selectedId: (o == null ? void 0 : o.color) ?? null,
          ariaLabel: "Shingle color",
          onSelect: (d) => s({ type: "SELECT_COLOR", stepId: "roofing", colorId: d.id })
        }
      )
    ] })
  ] });
}
const ue = [
  { field: "firstName", label: "First Name", type: "text", autoComplete: "given-name" },
  { field: "lastName", label: "Last Name", type: "text", autoComplete: "family-name" },
  { field: "email", label: "Email", type: "email", autoComplete: "email", wide: !0 },
  { field: "phone", label: "Phone", type: "tel", autoComplete: "tel" },
  { field: "zip", label: "ZIP Code", type: "text", autoComplete: "postal-code" }
];
function me({ submitting: e, submitError: s, onSubmit: r }) {
  const { state: i, dispatch: o } = x();
  return /* @__PURE__ */ c("form", { className: "shdcfg-form", onSubmit: r, noValidate: !0, children: [
    /* @__PURE__ */ t("h3", { className: "shdcfg-form-title", children: "Reserve your build" }),
    /* @__PURE__ */ t("p", { className: "shdcfg-form-sub", children: "Enter your details to continue to secure checkout." }),
    /* @__PURE__ */ t("div", { className: "shdcfg-form-grid", children: ue.map(({ field: n, label: a, type: h, autoComplete: d, wide: l }) => {
      const f = i.leadErrors[n], p = `shdcfg-lead-${n}`;
      return /* @__PURE__ */ c(
        "div",
        {
          className: `shdcfg-field${l ? " is-wide" : ""}${f ? " has-error" : ""}`,
          children: [
            /* @__PURE__ */ c("label", { htmlFor: p, children: [
              a,
              " *"
            ] }),
            /* @__PURE__ */ t(
              "input",
              {
                id: p,
                type: h,
                autoComplete: d,
                required: !0,
                value: i.lead[n],
                "aria-invalid": !!f,
                "aria-describedby": f ? `${p}-error` : void 0,
                onChange: (g) => o({ type: "SET_LEAD_FIELD", field: n, value: g.target.value }),
                onBlur: () => o({ type: "BLUR_LEAD_FIELD", field: n })
              }
            ),
            f && /* @__PURE__ */ t("span", { className: "shdcfg-field-error", id: `${p}-error`, role: "alert", children: f })
          ]
        },
        n
      );
    }) }),
    s && /* @__PURE__ */ t("p", { className: "shdcfg-error", role: "alert", children: s }),
    /* @__PURE__ */ t("button", { type: "submit", className: "shdcfg-btn shdcfg-btn-primary", "aria-disabled": e, children: e ? "Opening checkout…" : "Continue to Secure Checkout" }),
    /* @__PURE__ */ t("p", { className: "shdcfg-form-disclaimer", children: "Secure payment powered by Stripe — a deposit reserves your build." }),
    /* @__PURE__ */ c("div", { className: "shdcfg-phone-callout", children: [
      /* @__PURE__ */ t("span", { className: "shdcfg-phone-callout-label", children: "Questions before you pay your deposit? Give us a call:" }),
      /* @__PURE__ */ t("a", { href: "tel:+16822040561", className: "shdcfg-phone-callout-number", children: "(682) 204-0561" })
    ] })
  ] });
}
function xe({ onQuoteSubmit: e }) {
  const { state: s, dispatch: r, config: i } = x(), o = N(s, i), [n, a] = _(!1), [h, d] = _(null), l = (p) => p !== "model" || !(s.modelLocked && s.dimensionsLocked), f = async (p) => {
    if (p.preventDefault(), n || (r({ type: "SUBMIT_ATTEMPT" }), Object.keys(B(s.lead)).length > 0)) return;
    const g = G(s, i, (/* @__PURE__ */ new Date()).toISOString());
    d(null), a(!0);
    try {
      await e(g), r({ type: "SUBMIT_SUCCESS" });
    } catch {
      d("We couldn't open checkout. Please try again.");
    } finally {
      a(!1);
    }
  };
  return /* @__PURE__ */ c(
    k,
    {
      heading: b.quote,
      subheading: "Review every selection — use Edit to change anything. Your other choices are preserved.",
      children: [
        /* @__PURE__ */ t("ul", { className: "shdcfg-quote-list", children: o.lineItems.map((p) => /* @__PURE__ */ c("li", { className: "shdcfg-quote-item", children: [
          /* @__PURE__ */ t("span", { className: "shdcfg-quote-item-label", children: p.label }),
          /* @__PURE__ */ t("span", { className: "shdcfg-quote-item-detail", children: p.detail }),
          /* @__PURE__ */ t(
            "span",
            {
              className: `shdcfg-quote-item-price${p.included ? " is-included" : ""}`,
              children: p.stepId === "model" ? "—" : p.included ? "Included — $0.00" : p.price
            }
          ),
          l(p.stepId) && /* @__PURE__ */ t(
            "button",
            {
              type: "button",
              className: "shdcfg-edit-link",
              onClick: () => r({ type: "EDIT_STEP", stepId: p.stepId }),
              "aria-label": `Edit ${p.label}`,
              children: "Edit"
            }
          )
        ] }, p.stepId)) }),
        /* @__PURE__ */ c("div", { className: "shdcfg-quote-grand", children: [
          /* @__PURE__ */ t("span", { children: "Grand total" }),
          /* @__PURE__ */ t("strong", { children: I(o.totalCents) })
        ] }),
        /* @__PURE__ */ t(me, { submitting: n, submitError: h, onSubmit: f })
      ]
    }
  );
}
function w({ stepId: e, subheading: s }) {
  const { state: r, dispatch: i, config: o } = x(), n = E(e, r, o), a = D(e, r, o);
  return /* @__PURE__ */ t(k, { heading: b[e], subheading: s, children: /* @__PURE__ */ t(
    L,
    {
      options: n,
      selectedId: (a == null ? void 0 : a.optionId) ?? null,
      ariaLabel: b[e],
      onSelect: (h) => i({ type: "SELECT_OPTION", stepId: e, optionId: h.id, depthFt: h.depthFt })
    }
  ) });
}
const be = `
.shdcfg{
  --shdcfg-primary:#1B6FE8;
  --shdcfg-radius:10px;
  --shdcfg-font:'Avenir Next','Seravek','Gill Sans',ui-sans-serif,system-ui,'Segoe UI',sans-serif;
  --shdcfg-text:#0f172a;
  --shdcfg-muted:#64748b;
  --shdcfg-border:#e2e8f0;
  --shdcfg-surface:#ffffff;
  --shdcfg-bg:#ffffff;
  --shdcfg-success:#176f44;
  --shdcfg-danger:#b3261e;

  font-family:var(--shdcfg-font);
  color:var(--shdcfg-text);
  font-size:16px;
  line-height:1.45;
  box-sizing:border-box;
  background:var(--shdcfg-bg);
  border:1px solid var(--shdcfg-border);
  border-radius:calc(var(--shdcfg-radius) + 6px);
  padding:clamp(14px,3vw,26px);
  font-variant-numeric:tabular-nums;
  -webkit-font-smoothing:antialiased;
}
.shdcfg *,.shdcfg *::before,.shdcfg *::after{box-sizing:inherit;margin:0;padding:0;font:inherit;color:inherit}
.shdcfg button{background:none;border:none;cursor:pointer;text-align:inherit}
.shdcfg :focus{outline:none}
.shdcfg :focus-visible{outline:3px solid var(--shdcfg-primary);outline-offset:2px;border-radius:4px}
.shdcfg-sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap;border:0}

/* ---------- Stepper ---------- */
.shdcfg-stepper{margin-bottom:20px}
.shdcfg-stepper-groups{display:flex;gap:4px;list-style:none;flex-wrap:wrap;margin-bottom:10px}
.shdcfg-stepper-group{display:flex;align-items:center;gap:7px;padding:6px 12px 6px 7px;border-radius:999px;font-size:13.5px;color:var(--shdcfg-muted);letter-spacing:.01em}
.shdcfg-stepper-group .shdcfg-stepper-num{display:inline-flex;align-items:center;justify-content:center;width:22px;height:22px;border-radius:50%;border:1.5px solid var(--shdcfg-border);background:var(--shdcfg-surface);font-size:12px;font-weight:700}
.shdcfg-stepper-group.is-done{color:var(--shdcfg-text)}
.shdcfg-stepper-group.is-done .shdcfg-stepper-num{background:var(--shdcfg-primary);border-color:var(--shdcfg-primary);color:#fff}
.shdcfg-stepper-group.is-current{color:var(--shdcfg-text);font-weight:700;background:var(--shdcfg-surface);box-shadow:0 1px 3px rgba(20,30,40,.08)}
.shdcfg-stepper-group.is-current .shdcfg-stepper-num{border-color:var(--shdcfg-primary);color:var(--shdcfg-primary)}
.shdcfg-stepper-track{height:6px;border-radius:999px;background:var(--shdcfg-border);overflow:hidden}
.shdcfg-stepper-fill{height:100%;border-radius:999px;background:var(--shdcfg-primary);transition:width .35s ease}

/* ---------- Layout ---------- */
.shdcfg-layout{display:grid;grid-template-columns:minmax(0,1fr) 330px;gap:24px;align-items:start}
.shdcfg-main{min-width:0}
.shdcfg-step-heading{font-size:clamp(21px,3vw,26px);font-weight:800;letter-spacing:-.01em;margin:2px 0 4px}
.shdcfg-step-sub{color:var(--shdcfg-muted);font-size:14.5px;margin-bottom:18px}
.shdcfg-section-label{font-size:13px;font-weight:700;text-transform:uppercase;letter-spacing:.08em;color:var(--shdcfg-muted);margin:22px 0 10px}

/* ---------- Option cards ---------- */
.shdcfg-options{display:grid;grid-template-columns:repeat(auto-fill,minmax(225px,1fr));gap:14px}
.shdcfg-card{position:relative;display:flex;flex-direction:column;background:var(--shdcfg-surface);border:1.75px outset oklch(75% .015 230);border-radius:var(--shdcfg-radius);overflow:hidden;cursor:pointer;transition:border-color .15s ease,box-shadow .15s ease,transform .15s ease,opacity .15s ease;text-align:left;box-shadow:.5px .2px 5.3px -1.75px oklch(38% .122 250),0 .2px 4.5px -1.15px inset oklch(20% .13 230 / .92),.5px -2.2px 13px -3.2px inset oklch(80% .085 240),.5px -.2px 8.5px .2px oklch(90% .5 130 / .1)}
.shdcfg-card:hover{transform:translateY(-1px)}
/* Once a choice is made, quiet the passed-over options a touch (hover restores). */
.shdcfg-options:has(.is-selected) .shdcfg-card:not(.is-selected){opacity:.85}
.shdcfg-options:has(.is-selected) .shdcfg-card:not(.is-selected):hover{opacity:1}
.shdcfg-card.is-selected{border:2px ridge #80cbc8;box-shadow:0 0px 1.5px .5px inset oklch(68% .2 220),0 30px 13px oklch(50% .002 40 / .35)!important}
.shdcfg-card.is-locked{cursor:default;background:linear-gradient(180deg,color-mix(in srgb,var(--shdcfg-primary) 5%,var(--shdcfg-surface)),var(--shdcfg-surface))}
.shdcfg-card.is-locked:hover{transform:none}
.shdcfg-card-media{height:128px;display:flex;align-items:center;justify-content:center;background:color-mix(in srgb,var(--shdcfg-border) 30%,var(--shdcfg-surface))}
.shdcfg-card-photo{width:100%;height:100%;object-fit:cover;display:block}
.shdcfg-card-photo--contain{object-fit:contain;padding:16px}
/* Model-selection cards stand twice as tall as standard option cards. */
.shdcfg-options--model .shdcfg-card-media{height:184px}
.shdcfg-card-body{display:flex;flex-direction:column;gap:5px;padding:13px 15px 15px;flex:1}
.shdcfg-card-title{font-weight:700;font-size:16.5px}
.shdcfg-card-note{color:var(--shdcfg-muted);font-size:13.5px}
.shdcfg-card-price{margin-top:auto;padding-top:8px;font-weight:700;font-size:14.5px}
.shdcfg-card-included-badge{display:inline-block;margin-bottom:2px;font-size:12.5px;font-weight:700;color:var(--shdcfg-success)}

/* ---------- Swatches ---------- */
.shdcfg-swatches{display:grid;grid-template-columns:repeat(auto-fill,minmax(140px,1fr));gap:12px}
.shdcfg-swatch{position:relative;border:2px solid var(--shdcfg-border);border-radius:var(--shdcfg-radius);overflow:hidden;cursor:pointer;background:var(--shdcfg-surface);transition:border-color .15s ease,box-shadow .15s ease,opacity .15s ease;padding:0;display:block;width:100%}
.shdcfg-swatches:has(.is-selected) .shdcfg-swatch:not(.is-selected){opacity:.85}
.shdcfg-swatches:has(.is-selected) .shdcfg-swatch:not(.is-selected):hover{opacity:1}
.shdcfg-swatch:hover{border-color:color-mix(in srgb,var(--shdcfg-primary) 55%,var(--shdcfg-border))}
.shdcfg-swatch.is-selected{border:2px ridge #80cbc8;box-shadow:0 0 1.5px .5px inset oklch(68% .2 220),0 10px 8px -4px oklch(50% .002 40 / .3)}
.shdcfg-swatch-chip{height:62px}
.shdcfg-swatch-label{display:block;padding:7px 9px;font-size:13px;font-weight:600;border-top:1px solid var(--shdcfg-border);background:var(--shdcfg-surface);text-align:center}
.shdcfg-swatch.is-selected .shdcfg-swatch-label{font-weight:700}

/* ---------- Chips (loft depth, shelving qty) ---------- */
.shdcfg-chips{display:flex;gap:10px;flex-wrap:wrap}
.shdcfg-chip{padding:9px 18px;border-radius:999px;border:2px solid var(--shdcfg-border);background:var(--shdcfg-surface);font-weight:600;font-size:14.5px;cursor:pointer;transition:border-color .15s ease,opacity .15s ease}
.shdcfg-chips:has(.is-selected) .shdcfg-chip:not(.is-selected){opacity:.85}
.shdcfg-chips:has(.is-selected) .shdcfg-chip:not(.is-selected):hover{opacity:1}
.shdcfg-chip:hover{border-color:color-mix(in srgb,var(--shdcfg-primary) 55%,var(--shdcfg-border))}
.shdcfg-chip.is-selected{border:2px ridge #80cbc8;background:color-mix(in srgb,#80cbc8 12%,var(--shdcfg-surface))}
.shdcfg-constraint{display:flex;gap:7px;align-items:baseline;margin:10px 0 0;font-size:13.5px;color:var(--shdcfg-muted)}

/* ---------- Nav / Continue bar ---------- */
.shdcfg-error{margin-top:14px;padding:11px 14px;border-radius:var(--shdcfg-radius);border:1px solid color-mix(in srgb,var(--shdcfg-danger) 35%,var(--shdcfg-border));background:color-mix(in srgb,var(--shdcfg-danger) 7%,var(--shdcfg-surface));color:var(--shdcfg-danger);font-size:14px;font-weight:600}
.shdcfg-nav{display:flex;align-items:center;gap:14px;margin-top:22px}
.shdcfg-btn{padding:12px 26px;border-radius:calc(var(--shdcfg-radius) - 2px);font-weight:700;font-size:15.5px;letter-spacing:.01em;transition:box-shadow .15s ease,transform .15s ease,opacity .15s ease,background-color .15s ease}
.shdcfg button.shdcfg-btn-primary{background:var(--shdcfg-primary);color:#fff;border:1.75px outset oklch(70% .12 255);box-shadow:0 1.5px 3.5px -1px inset oklch(90% .07 250 / .8),0 -2.5px 8px -3px inset oklch(28% .13 255 / .85),.5px 1.2px 5.3px -1.75px oklch(38% .122 250)}
.shdcfg-btn-primary:not([aria-disabled="true"]):hover{transform:translateY(-1px);box-shadow:0 1.5px 3.5px -1px inset oklch(90% .07 250 / .8),0 -2.5px 8px -3px inset oklch(28% .13 255 / .85),.5px 3px 9px -2px oklch(38% .122 250 / .8)}
.shdcfg-btn-primary:not([aria-disabled="true"]):active{transform:translateY(.5px);box-shadow:0 2px 6px -1px inset oklch(25% .12 255 / .9)}
.shdcfg-btn-primary[aria-disabled="true"]{opacity:.45;cursor:not-allowed;box-shadow:none;border-color:var(--shdcfg-border)}
.shdcfg button.shdcfg-btn-ghost{border:1.75px outset oklch(75% .015 230);color:var(--shdcfg-text);background:var(--shdcfg-surface);box-shadow:.5px .2px 5.3px -1.75px oklch(38% .03 250 / .55),.5px -2.2px 10px -3.2px inset oklch(85% .012 240)}
.shdcfg-btn-ghost:not(:disabled):hover{transform:translateY(-1px)}
.shdcfg-btn-ghost:not(:disabled):active{transform:translateY(.5px);box-shadow:0 2px 6px -1px inset oklch(60% .02 250 / .5)}
.shdcfg-btn-ghost:disabled{opacity:.4;cursor:not-allowed;box-shadow:none}
.shdcfg-nav-total{margin-left:auto;font-size:14px;color:var(--shdcfg-muted);display:none}
.shdcfg-nav-total strong{display:block;font-size:18px;color:var(--shdcfg-text);font-weight:800}

/* ---------- Summary rail (quote ticket) ---------- */
.shdcfg-rail{position:sticky;top:16px}
.shdcfg-ticket{background:var(--shdcfg-surface);border:1px solid var(--shdcfg-border);border-radius:var(--shdcfg-radius);padding:18px 18px 14px;box-shadow:0 2px 10px rgba(20,30,40,.05)}
.shdcfg-ticket-title{font-size:13px;font-weight:800;text-transform:uppercase;letter-spacing:.1em;color:var(--shdcfg-muted);margin-bottom:12px;display:flex;justify-content:space-between;align-items:center}
.shdcfg-ticket-rows{list-style:none;display:flex;flex-direction:column;gap:9px}
.shdcfg-ticket-row{display:flex;justify-content:space-between;gap:12px;font-size:13.5px;align-items:baseline}
.shdcfg-ticket-row .shdcfg-ticket-detail{color:var(--shdcfg-muted);display:block;font-size:12.5px}
.shdcfg-ticket-row.is-included .shdcfg-ticket-price{color:var(--shdcfg-success);font-weight:700}
.shdcfg-ticket-price{white-space:nowrap;font-weight:600}
.shdcfg-ticket-total{display:flex;justify-content:space-between;align-items:baseline;margin-top:14px;padding-top:13px;border-top:2px dashed var(--shdcfg-border);font-weight:800;font-size:15px}
.shdcfg-ticket-total strong{font-size:21px;letter-spacing:-.01em}
.shdcfg-ticket-hint{margin-top:10px;font-size:12px;color:var(--shdcfg-muted)}
.shdcfg-drawer{display:none;margin-bottom:14px;border:1px solid var(--shdcfg-border);border-radius:var(--shdcfg-radius);background:var(--shdcfg-surface)}
.shdcfg-drawer>summary{cursor:pointer;padding:12px 14px;font-weight:700;font-size:14.5px;display:flex;justify-content:space-between;list-style:none}
.shdcfg-drawer>summary::-webkit-details-marker{display:none}
.shdcfg-drawer .shdcfg-ticket{border:none;box-shadow:none;padding-top:2px}

/* ---------- Quote summary table ---------- */
.shdcfg-quote-list{list-style:none;background:var(--shdcfg-surface);border:1px solid var(--shdcfg-border);border-radius:var(--shdcfg-radius);overflow:hidden;margin-bottom:8px}
.shdcfg-quote-item{display:flex;align-items:center;gap:14px;padding:13px 16px;border-bottom:1px solid var(--shdcfg-border)}
.shdcfg-quote-item:last-child{border-bottom:none}
.shdcfg-quote-item-label{font-size:12.5px;font-weight:700;text-transform:uppercase;letter-spacing:.07em;color:var(--shdcfg-muted);width:118px;flex-shrink:0}
.shdcfg-quote-item-detail{flex:1;font-size:14.5px;min-width:0}
.shdcfg-quote-item-price{font-weight:700;white-space:nowrap}
.shdcfg-quote-item-price.is-included{color:var(--shdcfg-success)}
.shdcfg-edit-link{color:var(--shdcfg-primary);font-weight:700;font-size:13.5px;text-decoration:underline;text-underline-offset:2px;flex-shrink:0}
.shdcfg-quote-grand{display:flex;justify-content:flex-end;gap:18px;align-items:baseline;padding:14px 16px;font-weight:800;font-size:16px}
.shdcfg-quote-grand strong{font-size:24px;letter-spacing:-.01em}

/* ---------- Lead form ---------- */
.shdcfg-form{margin-top:24px;background:var(--shdcfg-surface);border:1px solid var(--shdcfg-border);border-radius:var(--shdcfg-radius);padding:20px}
.shdcfg-form-title{font-weight:800;font-size:18px;margin-bottom:4px}
.shdcfg-form-sub{color:var(--shdcfg-muted);font-size:13.5px;margin-bottom:16px}
.shdcfg-form-grid{display:grid;grid-template-columns:1fr 1fr;gap:14px}
.shdcfg-field{display:flex;flex-direction:column;gap:5px}
.shdcfg-field.is-wide{grid-column:1/-1}
.shdcfg-field label{font-size:13px;font-weight:700}
.shdcfg-field input{padding:11px 13px;border:1.5px solid var(--shdcfg-border);border-radius:calc(var(--shdcfg-radius) - 3px);background:var(--shdcfg-surface);font-size:15px;width:100%}
.shdcfg-field input:focus-visible{outline-width:2px;outline-offset:0;border-color:var(--shdcfg-primary)}
.shdcfg-field.has-error input{border-color:var(--shdcfg-danger)}
.shdcfg-field-error{font-size:12.5px;color:var(--shdcfg-danger);font-weight:600}
.shdcfg-form .shdcfg-btn{margin-top:18px;width:100%}
.shdcfg-form-disclaimer{margin-top:10px;font-size:12px;color:var(--shdcfg-muted);text-align:center}
.shdcfg-phone-callout{margin-top:16px;padding:14px 16px;border:2px solid var(--shdcfg-primary);border-radius:var(--shdcfg-radius);text-align:center;display:flex;flex-direction:column;gap:4px}
.shdcfg-phone-callout-label{font-size:13.5px;font-weight:700}
.shdcfg-phone-callout-number{font-size:28px;font-weight:900;letter-spacing:.01em;color:var(--shdcfg-primary);text-decoration:none;white-space:nowrap}
.shdcfg-phone-callout-number:hover{text-decoration:underline}

/* ---------- Success ---------- */
.shdcfg-success{background:var(--shdcfg-surface);border:1px solid var(--shdcfg-border);border-radius:var(--shdcfg-radius);padding:38px 26px;text-align:center}
.shdcfg-success-icon{width:54px;height:54px;border-radius:50%;background:var(--shdcfg-success);color:#fff;display:inline-flex;align-items:center;justify-content:center;margin-bottom:14px}
.shdcfg-success-icon svg{width:26px;height:26px}
.shdcfg-success h3{font-size:22px;font-weight:800;margin-bottom:6px}
.shdcfg-success p{color:var(--shdcfg-muted);font-size:14.5px;max-width:42ch;margin:0 auto 6px}
.shdcfg-success .shdcfg-btn{margin-top:16px}

/* ---------- Read-only confirmation card (prop-driven Step 0) ---------- */
.shdcfg-confirm{display:flex;gap:16px;align-items:center;background:var(--shdcfg-surface);border:2px solid var(--shdcfg-primary);border-radius:var(--shdcfg-radius);padding:18px 20px;max-width:560px}
.shdcfg-confirm-title{font-weight:800;font-size:18px}
.shdcfg-confirm-note{color:var(--shdcfg-muted);font-size:13.5px}

/* ---------- Responsive ---------- */
/* Desktop: spread out — wider rail, bigger gaps, taller photos, denser grids. */
@media (min-width:1100px){
  .shdcfg{padding:32px 36px}
  .shdcfg-layout{grid-template-columns:minmax(0,1fr) 372px;gap:40px}
  .shdcfg-options{grid-template-columns:repeat(auto-fill,minmax(248px,1fr));gap:20px}
  .shdcfg-card-media{height:172px}
  .shdcfg-options--model .shdcfg-card-media{height:220px}
  .shdcfg-swatches{grid-template-columns:repeat(auto-fill,minmax(132px,1fr));gap:14px}
  .shdcfg-rail{top:24px}
  .shdcfg-ticket{padding:22px 22px 18px}
  .shdcfg-step-sub{font-size:15.5px;margin-bottom:24px}
}
@media (min-width:1500px){
  .shdcfg-options{grid-template-columns:repeat(auto-fill,minmax(270px,1fr))}
  .shdcfg-card-media{height:188px}
}
@media (max-width:900px){
  .shdcfg-layout{grid-template-columns:1fr}
  .shdcfg-rail{display:none}
  .shdcfg-drawer{display:block}
}
@media (max-width:640px){
  .shdcfg{padding:12px}
  .shdcfg-options{grid-template-columns:1fr}
  .shdcfg-swatches{grid-template-columns:repeat(2,minmax(0,1fr))}
  .shdcfg-form-grid{grid-template-columns:1fr}
  .shdcfg-nav{position:sticky;bottom:0;background:var(--shdcfg-bg);padding:12px 0;border-top:1px solid var(--shdcfg-border);z-index:3}
  .shdcfg-nav-total{display:block;text-align:right}
  .shdcfg-btn{padding:12px 20px}
  .shdcfg-quote-item{flex-wrap:wrap}
  .shdcfg-quote-item-label{width:100%}
}
@media (prefers-reduced-motion:reduce){
  .shdcfg *{transition:none!important;animation:none!important;scroll-behavior:auto!important}
}
`, A = "data-shdcfg";
function ve(e) {
  if (typeof document > "u" && !e) return;
  const s = e ?? document;
  if (s.head.querySelector(`style[${A}]`)) return;
  const r = s.createElement("style");
  r.setAttribute(A, ""), r.textContent = be, s.head.appendChild(r);
}
const O = "shdcfg:state:v1", we = {
  primary: "--shdcfg-primary",
  radius: "--shdcfg-radius",
  font: "--shdcfg-font",
  text: "--shdcfg-text",
  muted: "--shdcfg-muted",
  border: "--shdcfg-border",
  surface: "--shdcfg-surface",
  bg: "--shdcfg-bg"
};
function ye(e) {
  const s = V({
    initialModel: e.initialModel,
    initialDimensions: e.initialDimensions
  });
  if (typeof window > "u") return s;
  try {
    const r = window.sessionStorage.getItem(O);
    if (!r) return s;
    const i = JSON.parse(r);
    return typeof (i == null ? void 0 : i.stepIndex) != "number" || typeof (i == null ? void 0 : i.selections) != "object" ? s : {
      ...s,
      ...i,
      model: s.modelLocked ? s.model : i.model,
      dimensions: s.dimensionsLocked ? s.dimensions : i.dimensions,
      modelLocked: s.modelLocked,
      dimensionsLocked: s.dimensionsLocked,
      submitted: !1,
      stepIndex: Math.min(i.stepIndex, S.length - 1)
    };
  } catch {
    return s;
  }
}
function ke(e) {
  if (!(typeof window > "u"))
    try {
      e.submitted ? window.sessionStorage.removeItem(O) : window.sessionStorage.setItem(O, JSON.stringify(e));
    } catch {
    }
}
function ze(e) {
  const { onStepChange: s, onQuoteSubmit: r } = e, i = z(
    () => Q(Y, e.config),
    [e.config]
  ), o = z(() => K(i), [i]), [n, a] = Z(o, e, ye), h = T(null), d = T(!1);
  C(() => {
    var g;
    ve((g = h.current) == null ? void 0 : g.ownerDocument);
  }, []), C(() => {
    ke(n);
  }, [n]), C(() => {
    var g;
    if (!d.current) {
      d.current = !0;
      return;
    }
    s == null || s(S[n.stepIndex], n), (g = h.current) == null || g.scrollIntoView({ behavior: "smooth", block: "start" });
  }, [n.stepIndex]);
  const l = z(() => {
    var m;
    const g = {};
    for (const [v, u] of Object.entries(we)) {
      const P = (m = e.theme) == null ? void 0 : m[v];
      P && (g[u] = P);
    }
    return g;
  }, [e.theme]), f = S[n.stepIndex], p = z(() => ({ state: n, dispatch: a, config: i }), [n, i]);
  return /* @__PURE__ */ t(R.Provider, { value: p, children: /* @__PURE__ */ c("div", { className: "shdcfg", style: l, ref: h, children: [
    /* @__PURE__ */ t("span", { className: "shdcfg-sr-only", "aria-live": "polite", role: "status", children: n.submitted ? "Quote request sent." : `Step ${n.stepIndex + 1} of ${S.length}: ${b[f]}` }),
    /* @__PURE__ */ t(ne, {}),
    /* @__PURE__ */ c("div", { className: "shdcfg-layout", children: [
      /* @__PURE__ */ c("main", { className: "shdcfg-main", children: [
        !n.submitted && /* @__PURE__ */ t(ie, {}),
        n.submitted ? /* @__PURE__ */ t(Ie, {}) : /* @__PURE__ */ c(y, { children: [
          Se(f, r),
          f !== "quote" && /* @__PURE__ */ t(re, {}),
          f === "quote" && /* @__PURE__ */ t(Ne, {})
        ] })
      ] }),
      !n.submitted && /* @__PURE__ */ t(de, {})
    ] })
  ] }) });
}
function Se(e, s) {
  switch (e) {
    case "model":
      return /* @__PURE__ */ t(ce, {});
    case "paint":
      return /* @__PURE__ */ t(he, {});
    case "flooring":
      return /* @__PURE__ */ t(w, { stepId: "flooring", subheading: "Priced against your shed's floor area." });
    case "foundation":
      return /* @__PURE__ */ t(w, { stepId: "foundation", subheading: "Unlevel sites are leveled with cinderblocks, priced per floor sq ft." });
    case "delivery":
      return /* @__PURE__ */ t(w, { stepId: "delivery", subheading: "Tell us if a fence headache board, gate, slope, or anything else could block the delivery truck." });
    case "anchors":
      return /* @__PURE__ */ t(w, { stepId: "anchors", subheading: "Auger anchors tie the shed down — recommended in high-wind areas." });
    case "ramp":
      return /* @__PURE__ */ t(w, { stepId: "ramp" });
    case "workbench":
      return /* @__PURE__ */ t(w, { stepId: "workbench" });
    case "loft":
      return /* @__PURE__ */ t(pe, {});
    case "shelving":
      return /* @__PURE__ */ t(fe, {});
    case "venting":
      return /* @__PURE__ */ t(w, { stepId: "venting" });
    case "window":
      return /* @__PURE__ */ t(w, { stepId: "window" });
    case "roofing":
      return /* @__PURE__ */ t(ge, {});
    case "quote":
      return /* @__PURE__ */ t(xe, { onQuoteSubmit: s });
    default:
      return null;
  }
}
function Ne() {
  const e = x();
  return /* @__PURE__ */ c("div", { className: "shdcfg-nav", children: [
    /* @__PURE__ */ t(
      "button",
      {
        type: "button",
        className: "shdcfg-btn shdcfg-btn-ghost",
        onClick: () => e.dispatch({ type: "BACK_STEP" }),
        children: "Back"
      }
    ),
    /* @__PURE__ */ c("div", { className: "shdcfg-nav-total", children: [
      "Current total",
      /* @__PURE__ */ t("strong", { children: I(N(e.state, e.config).totalCents) })
    ] })
  ] });
}
function Ie() {
  const e = x(), s = I(N(e.state, e.config).totalCents);
  return /* @__PURE__ */ c("div", { className: "shdcfg-success", role: "status", children: [
    /* @__PURE__ */ t("span", { className: "shdcfg-success-icon", children: /* @__PURE__ */ t(se, {}) }),
    /* @__PURE__ */ t("h3", { children: "Your build is saved!" }),
    /* @__PURE__ */ c("p", { children: [
      "Your ",
      s,
      " shed configuration is saved. Finish in the secure checkout window to reserve it with a deposit — or start another build below."
    ] }),
    /* @__PURE__ */ t(
      "button",
      {
        type: "button",
        className: "shdcfg-btn shdcfg-btn-ghost",
        onClick: () => e.dispatch({ type: "RESET" }),
        children: "Configure another shed"
      }
    )
  ] });
}
export {
  De as CONFIGURATOR_VERSION,
  Pe as MSG_SELECT_MODEL,
  qe as MSG_SELECT_TO_CONTINUE,
  _e as PRICED_STEPS,
  b as STEP_HEADINGS,
  Ae as STEP_LABELS,
  S as STEP_ORDER,
  O as STORAGE_KEY,
  ze as ShedConfigurator,
  Re as basePriceCents,
  G as buildQuotePayload,
  N as computeQuote,
  V as createInitialState,
  Y as defaultConfig,
  U as derivedDimensions,
  $e as floorSqFt,
  I as formatCents,
  D as getEffectiveSelection,
  Fe as getInclusion,
  E as getStepOptions,
  Me as includedOptionId,
  j as isStepComplete,
  je as isUpgradeOptionId,
  Ue as loftPriceCents,
  Be as loftUpgradeDeltaCents,
  Q as mergeConfig,
  Ge as optionPriceCents,
  Qe as optionTitle,
  Ye as paintableSqFt,
  Ke as priceQuote,
  K as reduce,
  Ve as shortestWallFt,
  q as stepIndexOf,
  B as validateLead,
  He as validateSelection
};
//# sourceMappingURL=index.js.map
